'use client'
const capitalize = (value) => { var _a; return ((_a = value[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) + value.slice(1).toLowerCase(); };

export { capitalize };
